export default __webpack_public_path__ + "static/media/signed_&_sealed.d6d8b111.svg";